import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import routing from "routing";
import PickerItems from "src/images/Icons/newIcons/itemsList.svg";
import CourseIcon from "src/images/Icons/newIcons/navigation/courses.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

function CoursesPicker() {
	const { t } = useTranslation();

	return (
		<DefaultPicker
			Header={
				<Header
					title={t("contentPicker.courses.title")}
					icon={<CourseIcon className={cx("icon-super-big icon-logo")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t("contentPicker.courses.create.title"),
					subtitle: t("contentPicker.courses.create.subtitle"),
					path: routing.paths.pickCourseType,
					submitText: t("commands.create"),
					Icon: PickerNewItem,
				},
				{
					title: t("contentPicker.courses.list.title"),
					subtitle: t("contentPicker.courses.list.subtitle"),
					path: routing.paths.userCourses,
					submitText: t("commands.browse"),
					Icon: PickerItems,
				},
			]}
		/>
	);
}

export default CoursesPicker;
